<template>
  <UiNarrowContainer>
    <div
      v-if="status === 'pending'"
      class="mb-24 mt-36 flex flex-col items-center rounded-xl border border-neutral-200"
    >
      <div class="flex w-full flex-col flex-wrap justify-center py-4 md:flex-row md:flex-nowrap">
        <div
          class="inline-flex flex-nowrap items-center justify-center py-3 md:w-full md:border-r md:border-r-neutral-100"
        >
          <UiSkeleton class="h-8 w-40" />
        </div>
        <div
          class="inline-flex flex-nowrap items-center justify-center py-3 md:w-full md:border-r md:border-r-neutral-100"
        >
          <UiSkeleton class="h-8 w-40" />
        </div>
        <div
          class="inline-flex flex-nowrap items-center justify-center py-3 md:w-full md:border-r md:border-r-neutral-100"
        >
          <UiSkeleton class="h-8 w-40" />
        </div>
        <div class="inline-flex flex-nowrap items-center justify-center py-3 md:w-full">
          <UiSkeleton class="h-8 w-40" />
        </div>
      </div>
    </div>
    <div
      v-else-if="cmsStore.reassurance?.reassurance_items.length"
      class="mb-24 mt-36 flex flex-col items-center rounded-xl border border-neutral-200"
    >
      <div class="flex w-full flex-col flex-wrap justify-center py-4 md:flex-row md:flex-nowrap">
        <div
          v-for="reassuranceItem in cmsStore.reassurance?.reassurance_items"
          :key="reassuranceItem.id"
          class="inline-flex flex-nowrap items-center justify-center py-3 md:w-full md:border-r-neutral-100 md:[&:not(:last-child)]:border-r"
        >
          <UiImage
            :id="reassuranceItem.id.toString()"
            class="mr-2 size-6"
            :src="reassuranceItem.icon?.url"
            :alt="reassuranceItem.icon?.alt_text ?? reassuranceItem.icon?.name ?? ''"
          />
          <UiText class="text-center">{{ reassuranceItem.title }}</UiText>
        </div>
      </div>
    </div>
  </UiNarrowContainer>
</template>

<script setup lang="ts">
import type { Locale } from '~/utils/common';

import { useCmsStore } from '~/stores/cms/cmsStore';

const { locale } = useI18n();

const cmsStore = useCmsStore();

const asyncData = await useAsyncData('reassurance-footer', async () => {
  if (!cmsStore.reassurance) return await cmsStore.fetchReassurance(locale.value as Locale);

  return cmsStore.reassurance;
});

const { status } = asyncData;

watch([locale], () => asyncData.refresh());
</script>
